import React, { useState } from "react";
import "./resumeResultStats.scss";
import { RDB_FILTER_DURATION_OPTIONS } from "../../helper/categoryconstants";

function ResumeResultStats({pageResult}) {

  const getUploadingtime = (value) =>{
    const label = RDB_FILTER_DURATION_OPTIONS.find(item => item.value === value)?.label || value;   
    return label
  }  
  return (
    <div className="resumeDBSearchResults-stats-wrapper">
      <div className="resumeDBSearchResults-title">
        <div className="resumeDBSearchResults-number">
          {pageResult?.totalresumes}
        </div>{" "}
        {pageResult?.totalresumes > 1 ? "Resumes" : "Resume"} Found
        <br></br>
        Uploaded in{" "}
        <span className="resumeDBSearchResults-time">
          {getUploadingtime(pageResult?.triggerreq?.duration)}
        </span>
      </div>
    </div>
  );
}

export default ResumeResultStats;
